window.page = {
    content: null,
    articleCollection: null,
    articleList: null,
    lightboxes: null,
    articleUrl: null,

    /**
     * Initialization of all Elements the Page
     * @return void
     */
    init: function() {
        this.content = document.querySelector(".main");
        this.initArticleCollection();
        this.initArticleList();
        this.initLightbox();
        this.initTwoColTeaserBox();
        this.initThreeColTeaserBox();
        this.initVimeo();
        this.initAbstractArticle();
        this.initText();
    },

    /**
     * Initialization of Article Collection Javascript if Article Collection Wrapper exists
     * @return void
     */
    initArticleCollection: function() {
        if (this.content.querySelector(".article__collection")) {
            this.articleCollection = this.content.querySelector(".article__collection");
            window.articleCollection.init(this.articleCollection);
        }
    },

    /**
     * Initialization of Article List Javascript if Article List Wrapper exists
     * @return void
     */
    initArticleList: function() {
        if (this.content.querySelector(".article--list")) {
            this.articleList = this.content.querySelector(".article--list");
            window.articleList.init(this.articleList);
        }
    },

    /**
     * Initialization of Lightbox Javascript if Lightbox Wrapper exists
     * @return void
     */
    initLightbox: function() {
        if (this.content.querySelector(".lightbox--wrapper")) {
            this.lightboxes = document.querySelectorAll(".lightbox");
            window.image.init(this.lightboxes);
        }
    },

    /**
     * Initialization of TwoColumnTeaser Javascript if TwoColumnTeaser exists
     * @return void
     */
    initTwoColTeaserBox: function() {
        if (this.content.querySelector(".grid--twocolumn6-6 .teaserbox")) {
            window.teaserbox.initTwoColumnTeaserBoxes();
        }
    },

    /**
     * Initialization of ThreeColumnTeaser Javascript if ThreeColumnTeaser exists
     * @return void
     */
    initThreeColTeaserBox: function() {
        if (this.content.querySelector(".grid--threecolumn .teaserbox")) {
            window.teaserbox.initThreeColumnTeaserBoxes();
        }
    },

    /**
     * Initialization of Vimeo Javascript if Vimeo exists
     * @return void
     */
    initVimeo: function() {
        if (this.content.querySelector(".prettyembed--wrapper")) {
            window.vimeo.init();
        }
    },

    /**
     * Initialization of Abstract Article Functions
     * @return void
     */
    initAbstractArticle: function () {
        if (this.content.querySelector(".article__url")) {
            this.articleUrl = this.content.querySelector(".article__url");
            window.abstractArticle.initArticleBackendUrl(this.articleUrl);
        }

        if (this.content.querySelector(".article__detail--newsletter")) {
            window.abstractArticle.initNewsletterOverlay(this.content.querySelector(".article__detail--newsletter"));
        }
    },

    /**
     * Initialization of Text Javascript if Text El exists
     * @return void
     */
    initText: function() {
        window.text.initTableScrollable();
    },
};
